module.exports = __webpack_public_path__ + "static/media/store_fasttrack.913c18eb.jpg";